(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.controller('ThirdPartyAppTableController', ['ItemTableService', '$state', ThirdPartyAppTableControllerFn]);

    /* controlle for main third-party-apps */
    function ThirdPartyAppTableControllerFn(ItemTableService, $state) {
        var vm = this;
        // the service -> here the ItemTableService
        vm.overview = null;

        /* search user */
        vm.searchUser = null;

        activate();

        // reset search
        vm.reset = function () {
            vm.searchUser = null;
        };

        // add new row to table
        vm.add = function () {
            ItemTableService.add();
        };

        // show all
        vm.showAll = function () {
            $state.go($state.current.name, { all: vm.overview.data.showAll }, { reload: $state.current.name });
        };

        /* activation work */
        function activate() {
            //service
            vm.overview = ItemTableService;

        }
    }
})();